export default __webpack_public_path__ + "static/media/plan_a.e7a83565.png";